import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Input, Popover, Radio, Row, Tabs } from "antd";
import "../../assets/css/custom.css";
import { ServerAPI } from "../../common/ServerAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoanApplicationCaseFilter } from "../../redux/slice/dealerCommFilterSlice";
import { AuthenticationContext } from "../../App";
import { CommomPermission } from "../../common/Constants";
import LoanTabDatas from "../LoanApplicationCases/LoanTabDatas";
import SortBy from "../LoanApplicationCases/SortBy";
import LoaderComp from "../../components/LoaderComp";

const DefaultFilters = {
  sortKey: "created_at",
  sortOrder: "desc", 
  id: 1,
  filter: "2",
  index: 1,
  provider_type: "",
  keyword: "",
};

const CaseList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pagePermission = location.state;
  const dispatch = useDispatch();
  const { authData, } = useContext(
    AuthenticationContext
  );
  const FlooringPErmission = authData?.permissions?.filter((it) => it.name === "loan")?.map((itx) => itx?.submodules).flat()?.filter((its) => its?.name === "new-loan-application");
  const FloorPagePErmission = FlooringPErmission !== undefined && FlooringPErmission?.length > 0 ? FlooringPErmission[0] : CommomPermission;

  const filters = useSelector(
    (state) => state.dealerCommFilter.loanApplicationCaseFilter
  );
  const settingsData = useSelector(
    (state) => state?.settings?.loanProviderTypes
  );
  const [listDetails, setListDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [applicationId, setApplicationId] = useState("");
  const [TotalData, setTotalData] = useState(0);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    apicall: true
  });
  const [applyFilters, setApplyFilters] = useState(
    Object.keys(filters)?.length > 0
      ? { ...filters, DefaultFilters }
      : DefaultFilters
  );

  const LoanCaseList = async (type) => {
    setLoading(true);
    try {
      let data = { ...applyFilters };
      delete data.id;
      const response = await ServerAPI.applicationList(
        data,
        type !== undefined && type !== null && type === "delete" ? 1 : pagination.currentPage,
        pagination.pageSize
      );
      if (response) {
        if (response.data) {
          setTotalData(response.total);
          if (type !== undefined && type !== null && type === "delete") {
            setListDetails(response.data);
          } else {
            setApplicationId(response?.data?.[0]?.id)
            setListDetails(listDetails?.length > 0 ? listDetails?.concat(response.data) : response.data);
          }

        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };


  const onPageChange = (obj) => {
    if (obj?.current > pagination?.currentPage) {
      setPagination({
        ...pagination,
        currentPage: obj.current,
        apicall: true
      });
    } else {
      setPagination({
        ...pagination,
        currentPage: obj.current,
        apicall: false
      });
    }
  };

  useEffect(() => {
    if (applicationId !== null && applicationId !== undefined) {
      localStorage.setItem('applicationId', applicationId);
    }
  }, [applicationId]);

  useEffect(() => {
    if (listDetails?.length < TotalData && pagination?.apicall) {
      LoanCaseList();
    }
  }, [pagination]);

  useEffect(() => {
    LoanCaseList();
    localStorage.removeItem("tabValue");
  }, []);

  return (
    <div className="w-full min-h-screen bg-[#F5F5F5] overflow-x-clip">
      <div className="bg-white">
        <section className="common_container !bg-white">
          <header className="common-header flex flex-wrap gap-5 justify-between">
            <div className="common-header-body">
              <h1>Dealer Commision Report</h1>
            </div>
          </header>
          <div className="app-container p-[0px_25px]">
            {loading ? (
              <LoaderComp />
            ) : (
              <LoanTabDatas
                data={listDetails}
                fetchLoanCase={LoanCaseList}
                type={"completed_disbursement"}
                pagePermission={pagePermission}
                onPageChange={onPageChange}
                pagination={pagination}
              />
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default CaseList;
